AngularRouter = App.loadClass 'core::Router'

class exports.Router extends AngularRouter

    prefix: 'AR'
    module_name: 'AdvisorRequestRouter'

    register: () ->
        @module = angular.module @module_name, ['ui.router', 'ui.bootstrap']

        @service 'grower::Angular/AdvisorRequest/Service', ['$http'], 'AdvisorService'

        @controller 'grower::Angular/AdvisorRequest/ManageController', [
            '$scope'
            '$transitions'
            '$uibModalInstance'
            'AR.AdvisorService'
        ], 'ManageController'

        @module.controller 'AdvisorRequestController', [
            '$scope',
            '$uibModal',
            'AR.AdvisorService'
            ($scope, $modal, $service) ->
                $service.fetchAdvisorRequest().then (requests) =>
                    if requests.length isnt 0
                        newscope = $scope.$new()
                        newscope.requests = requests
                        newscope.title = 'Respond to Connection Requests'

                        dlg = $modal.open
                            templateUrl: 'backend/grower/advisor-request/layout'
                            controller: 'AR.ManageController'
                            scope: newscope
        ]
